import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Button } from "@mui/material";
import { FormattedMessage as T } from "react-intl";
import { ImportUsersDialog } from "./ImportUsersDialog";
import { useBoolean } from "@knowfully/ui.common";

export function ImportUsers() {
  const [openImportUsersDialog, setOpenImportUsersDialog] = useBoolean(false);
  return (
    <>
      <Button
        startIcon={<FileUploadIcon />}
        onClick={setOpenImportUsersDialog.setTrue}
      >
        <T id="import" />
      </Button>
      <ImportUsersDialog
        open={openImportUsersDialog}
        onClose={setOpenImportUsersDialog.setFalse}
      />
    </>
  );
}
